import React, { useRef } from 'react';
import DraggableWindow from '../DraggableWindow';
import { useStreamingFeature } from './hooks/useStreamingFeature';

/**
 * DisplayModeWindow - Wraps streamed feature in draggable window
 * Used for desktop viewports (≥1024px)
 */
export function DisplayModeWindow({
  bundleUrl,
  title,
  onClose,
  position = { x: 100, y: 100 },
  size = { width: 1200, height: 800 },
  ...windowProps
}) {
  const containerRef = useRef(null);
  const { loading, error, mounted } = useStreamingFeature(bundleUrl, containerRef);

  // If embedded in window system, don't wrap in another DraggableWindow
  // The window system already provides the DraggableWindow
  if (windowProps.embedded) {
    return (
      <div 
        ref={containerRef}
        style={{ width: '100%', height: '100%' }}
        className="streaming-feature-container"
      >
        {loading && (
          <div className="flex items-center justify-center h-full bg-slate-900">
            <div className="text-white">Loading feature...</div>
          </div>
        )}
        {error && (
          <div className="flex items-center justify-center h-full bg-slate-900 p-4">
            <div className="text-red-400 text-center">
              <div className="font-semibold mb-2">Error loading feature</div>
              <div className="text-sm">{error}</div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <DraggableWindow
      title={title}
      onClose={onClose}
      position={position}
      size={size}
      {...windowProps}
    >
      <div 
        ref={containerRef}
        style={{ width: '100%', height: '100%' }}
        className="streaming-feature-container"
      >
        {loading && (
          <div className="flex items-center justify-center h-full bg-slate-900">
            <div className="text-white">Loading feature...</div>
          </div>
        )}
        {error && (
          <div className="flex items-center justify-center h-full bg-slate-900 p-4">
            <div className="text-red-400 text-center">
              <div className="font-semibold mb-2">Error loading feature</div>
              <div className="text-sm">{error}</div>
            </div>
          </div>
        )}
      </div>
    </DraggableWindow>
  );
}

